import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  mb16: {
    marginBottom: 16,
  },
}));

export default styles;
